import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "../cn";

export type PropsRkCard = HTMLAttributes<HTMLDivElement> & {
  readonly featured?: boolean;
  readonly interativo?: boolean;
  readonly children: ReactNode;
};

export function Card({
  featured = false,
  interativo = false,
  className,
  children,
  ...resto
}: PropsRkCard) {
  return (
    <div
      {...resto}
      className={cn(
        "rk-card",
        featured && "rk-card--featured",
        interativo && "rk-card--interactive",
        className,
      )}
    >
      {children}
    </div>
  );
}

export function CardTitle({
  className,
  children,
  ...resto
}: HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h3 {...resto} className={cn("rk-heading-sm rk-card__title", className)}>
      {children}
    </h3>
  );
}

export function CardDescription({
  className,
  children,
  ...resto
}: HTMLAttributes<HTMLParagraphElement>) {
  return (
    <p {...resto} className={cn("rk-body-sm rk-card__description", className)}>
      {children}
    </p>
  );
}

export function CardContent({
  className,
  children,
  ...resto
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div {...resto} className={cn(className)}>
      {children}
    </div>
  );
}
